module.exports = __webpack_public_path__ + "img/advance.71095915.png";